var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 55 55",
    width: 55,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M53 10C54.1 10 55 9.1 55 8C55 6.9 54.1 6 53 6C48 6 8 6 3 6C1.9 6 1 6.9 1 8C1 9.1 1.9 10 3 10C3 13.4 3 40.6 3 44C1.9 44 1 44.9 1 46C1 47.1 1.9 48 3 48C3.77 48 7.6 48 14.5 48L11 55L16 55L19.5 48L36.5 48L40 55L45 55L41.5 48C48.4 48 52.23 48 53 48C54.1 48 55 47.1 55 46C55 44.9 54.1 44 53 44C53 37.2 53 13.4 53 10ZM3 7C8 7 48 7 53 7C53.55 7 54 7.45 54 8C54 8.55 53.55 9 53 9C48 9 8 9 3 9C2.45 9 2 8.55 2 8C2 7.45 2.45 7 3 7ZM52 44L4 44L4 10L52 10L52 44ZM12.62 54L15.62 48L18.38 48L15.38 54L12.62 54ZM40.62 54L37.62 48L40.38 48L43.38 54L40.62 54ZM3 47C2.45 47 2 46.55 2 46C2 45.45 2.45 45 3 45C8 45 48 45 53 45C53.55 45 54 45.45 54 46C54 46.55 53.55 47 53 47C43 47 8 47 3 47Z",
    id: "b1LLx8T3sS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 2C28.55 2 29 2.45 29 3C29 3.13 29 3.8 29 5L30 5C30 3.8 30 3.13 30 3C30 1.9 29.1 1 28 1C26.9 1 26 1.9 26 3C26 3.13 26 3.8 26 5L27 5L27 3C27.3 2.33 27.63 2 28 2Z",
    id: "aV3rmIXd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16C14 16 14 16 14 16C14 16.6 14 16.93 14 17C14 17 14 17 14 17C9.2 17 6.53 17 6 17C6 17 6 17 6 17C6 16.4 6 16.07 6 16C6 16 6 16 6 16C10.8 16 13.47 16 14 16Z",
    id: "abaoFM3t"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13C14 13 14 13 14 13C14 13.6 14 13.93 14 14C14 14 14 14 14 14C9.2 14 6.53 14 6 14C6 14 6 14 6 14C6 13.4 6 13.07 6 13C6 13 6 13 6 13C10.8 13 13.47 13 14 13Z",
    id: "a7sbo20s0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 39C26 39 26 39 26 39C26 39.6 26 39.93 26 40C26 40 26 40 26 40C14 40 7.33 40 6 40C6 40 6 40 6 40C6 39.4 6 39.07 6 39C6 39 6 39 6 39C18 39 24.67 39 26 39Z",
    id: "dQD0OATKF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 30C50 30 50 30 50 30C50 30.6 50 30.93 50 31C50 31 50 31 50 31C38.6 31 32.27 31 31 31C31 31 31 31 31 31C31 30.4 31 30.07 31 30C31 30 31 30 31 30C42.4 30 48.73 30 50 30Z",
    id: "b1mitqL7PM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 34C50 34 50 34 50 34C50 34.6 50 34.93 50 35C50 35 50 35 50 35C38.6 35 32.27 35 31 35C31 35 31 35 31 35C31 34.4 31 34.07 31 34C31 34 31 34 31 34C42.4 34 48.73 34 50 34Z",
    id: "aKSrs3Fqd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 26C50 26 50 26 50 26C50 26.6 50 26.93 50 27C50 27 50 27 50 27C38.6 27 32.27 27 31 27C31 27 31 27 31 27C31 26.4 31 26.07 31 26C31 26 31 26 31 26C42.4 26 48.73 26 50 26Z",
    id: "b4rOY8wwsq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 38C39 38 39 38 39 38C39 38.6 39 38.93 39 39C39 39 39 39 39 39C34.2 39 31.53 39 31 39C31 39 31 39 31 39C31 38.4 31 38.07 31 38C31 38 31 38 31 38C35.8 38 38.47 38 39 38Z",
    id: "m4dsyR76qR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 13L47.64 13.4L46.8 14.57L48.47 14.29L44.89 19.29L40.91 16.31L36.86 21.37L32.83 19.36L30.58 22.72L31.42 23.28L33.17 20.65L37.14 22.63L41.09 17.69L45.11 20.71L49.28 14.87L49.56 16.54L50.39 15.36L50 13Z",
    id: "bw970pGfg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 38L8 38L8 31L10 31L10 38L11 38L11 30L7 30L7 38Z",
    id: "a2thuO6cO3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 38L15 38L15 25L17 25L17 38L18 38L18 24L14 24L14 38Z",
    id: "c4iO7keiG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 38L22 38L22 19L24 19L24 38L25 38L25 18L21 18L21 38Z",
    id: "apfvFMfGW"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1LLx8T3sS",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1LLx8T3sS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aV3rmIXd7",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aV3rmIXd7",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abaoFM3t",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abaoFM3t",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7sbo20s0",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7sbo20s0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dQD0OATKF",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dQD0OATKF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1mitqL7PM",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1mitqL7PM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKSrs3Fqd",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKSrs3Fqd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4rOY8wwsq",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4rOY8wwsq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m4dsyR76qR",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m4dsyR76qR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bw970pGfg",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bw970pGfg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2thuO6cO3",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2thuO6cO3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4iO7keiG",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4iO7keiG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#apfvFMfGW",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#apfvFMfGW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness3);
export default __webpack_public_path__ + "static/media/business-3.6c239d5f80b0034ec6ebc798ced4772d.svg";
export { ForwardRef as ReactComponent };